module.exports = __webpack_public_path__ + "static/media/campus.573ff018.png";